/* eslint-disable no-console */
import icons from '../Common/icons';

const SvgIcon = ({ name, size = 20, className = '' }: any) => {
    const Icon: any = icons[name];

    if (!Icon) {
        return null;
    }

    return (
        <span className={`d-inline-flex align-items-center justify-content-center ${className}`} style={{ width: size, height: size }}>
            <Icon width="100%" height="100%" fill="currentColor" />
        </span>
    );
};

export default SvgIcon;
